if (!window.Cookies) {
    const Cookies = require("js-cookie");
    window.Cookies = Cookies;
}

require("../../../../js/forms2.min.js")

window.addEventListener("load", async () => {
    const formId = 1694;
    prodId = "//app-sj01.marketo.com";

    function getMunchkinId() {
        return getMunchkinTokenByName("id") || "410-XOR-673";
    }

    const munchkinId = getMunchkinId();
    const getEmail = async (sfveclid) => {
        const response = await fetch(`/Main/SubscriptionsElementData/GetEmail/?sfveclid=${sfveclid}`);
        const emailAddress = await response.json();
        return emailAddress;
    };

    const getSfveclid = () => {
        const queryString = window.location.search;
        if (queryString == "") return null;
        const sfveclid = new URLSearchParams(queryString).get("sfveclid")?.split("/")[0];
        const cid = new URLSearchParams(queryString).get("cid")?.split("/")[0];
        if (cid !== undefined) return null;
        if (sfveclid !== undefined) return sfveclid;
    };

    const handleFormFunctionality = async (marketoTrackId) => {
        const sfveclid = getSfveclid() ?? localStorage.getItem("associate-sfveclid");
        if (!sfveclid) return;
        const emailAddress = await getEmail(sfveclid);
        if (emailAddress.Email == "") return;
        var formEl = document.createElement("FORM");
        [
            ["style", "visibility", "hidden"],
            ["style", "position", "absolute"],
            [null, "id", "mktoForm_" + formId],
        ].forEach(function (tup) {
            (formEl[tup[0]] || formEl)[tup[1]] = tup[2];
        });

        document.body.appendChild(formEl);
        MktoForms2.loadForm(prodId, marketoTrackId, formId, function (form) {
            form.addHiddenFields({
                Email: emailAddress.Email,
            });

            form
                .onSuccess(function (vals, tyURL) {
                    typeof callback == "function" && callback();
                    return false;
                })
                .submit();
            localStorage.removeItem("associate-sfveclid");
        });
    };

    function getMunchkinTokenByName(name) {
        var munchkinCookie = Cookies.get("_mkto_trk"); //$.cookie("_mkto_trk");  Uses new js-cookies lib rather than old jQuery lib (depreciated)
        var key = name + ":";
        var defaultResult = "";

        if (typeof munchkinCookie === "undefined") return defaultResult;

        var parts = munchkinCookie.split("&");

        for (index in parts) {
            if (startsWith(parts[index], key)) {
                return parts[index].slice(key.length);
            }
        }

        return defaultResult;
    }

    function startsWith(str, word) {
        return str.lastIndexOf(word, 0) === 0;
    }
    function isCalendlyEventScheduled(e) {
        return e.data.event && e.data.event === "calendly.event_scheduled";
    };

    const associateLead = async (eventId, inviteeId, mktoTrkValue) => {
        if (mktoTrkValue) {
            mktoTrkValue = encodeURIComponent(mktoTrkValue);
        }
        const response = await fetch(`/Main/Calendly/AssociateEvent/?eventId=${eventId}&inviteeId=${inviteeId}&mktoTrkValue=${mktoTrkValue}`);
    };

    window.addEventListener(
        "message",
        function (e) {
            if (isCalendlyEventScheduled(e)) {
                var munchkinCookie = Cookies.get("_mkto_trk");
                var segments = e.data.payload.invitee.uri.split("/");
                associateLead(segments[4], segments[6], munchkinCookie);
            }
        }
    );

    function ensureMarketoTrackingCookie(retryCount) {
        if (retryCount === 15) {
            console.log("15 seconds expired, stopping.");
            return;
        }

        const sfveclid = getSfveclid();
        if (sfveclid && !localStorage.getItem("associate-sfveclid")) {
            localStorage.setItem("associate-sfveclid", sfveclid);
        }

        var cookieValue = Cookies.get("_mkto_trk");
        if (!cookieValue) {
            setTimeout(function () {
                ensureMarketoTrackingCookie(retryCount + 1);
            }, 1000);
        } else {
            handleFormFunctionality(getMunchkinId());
        }
    }

    ensureMarketoTrackingCookie(0);
});